// AboutPage.js
import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import Seo from "../components/Seo";
import CountUp from "react-countup";
import Aboutnew from "../components/Aboutnew";

const AboutPage = () => {
  const handleSearchToggle = () => {
    // Implement your search toggle logic here
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <Seo
        title="Company Overview | Bioversal Remedies - Apply Today!"
        description="Company Overview. Bioversal Remedies is a trusted provider of Pharma franchise in all over the India. Explore our website to learn more!"
        type="webapp"
        name="Bioversal Remedies"
      />
      <section>
        <div className="container-fluid p-0">
          <div className="bg_cont__45__ab__out animate__animated animate__fadeIn">
         <h2 style={{ color: "rgb(255 255 255)", zIndex: 99 }}>
  Company Overview
</h2>
          </div>
        </div>
        {/* About us */}
        <Aboutnew />
      </section>

      <div>
        <section>
          <div className="container adorn-section">
            <h2>
              Adorning Your Healthcare By Delivering <br /> More Than Medicines!
            </h2>
            <p>
              Bioversal Remedies is dedicated to producing and distributing
              high-quality medicines and healthcare products while maintaining
              environmental protection, <br /> including health and well-being.
              Quality products, rescuing lives and affordability are our major
              work parameters.
            </p>
          </div>

          <div className="container">
            <div className="row justify-content-center mt-5">
              <div className="col-sm-6 col-md-3 adorn-card mx-3 card-margin">
                <div className="icon-design">
                  <svg
                    fill="#f28535"
                    className="mb-2"
                    stroke-width="2"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <title />
                    <path d="M23.658,4.269l-2.944-.982L19.732.342a.5.5,0,0,0-.843-.18l-2.758,3A.5.5,0,0,0,16,3.5V6.94l-1.2,1.194A8.992,8.992,0,0,0,2.043,20.7L.715,22.38a1,1,0,0,0,1.569,1.24l1.2-1.521a8.965,8.965,0,0,0,11.232-.154l1.534,1.72a1.013,1.013,0,0,0,1.412.081,1,1,0,0,0,.082-1.411L16.11,20.5a8.957,8.957,0,0,0,.532-10.245.257.257,0,0,0-.4-.042L14.6,11.859a.241.241,0,0,0-.043.284,6.281,6.281,0,1,1-1.7-2.055l-1.075,1.075a4.7,4.7,0,0,0-3.823-.8,4.751,4.751,0,1,0,5.659,5.773,4.708,4.708,0,0,0-.121-2.672.252.252,0,0,0-.415-.086l-2.16,2.159a1.99,1.99,0,1,1-1.135-2.382L8.6,14.34a.75.75,0,0,0,0,1.061.764.764,0,0,0,1.061,0L17.06,8H20.5a.5.5,0,0,0,.339-.132l3-2.756a.5.5,0,0,0,.151-.473A.5.5,0,0,0,23.658,4.269Z" />
                  </svg>
                </div>
                <p className="fs-5 mb-2 adorn-card-heading">Our Vision</p>
                <p className="card-description">
                  Our vision is to become a global hub for restoring the health
                  and lives of our valued patients. We believe in accelerating
                  our reach to maximum people with effective medicinal remedies
                  to people's physical and mental health problems globally. We
                  aim to become a premier healthcare organization powered by
                  persistent innovation and research, constantly seeking new
                  possibilities in human healthcare.
                </p>
              </div>
              <div className="col-sm-6 col-md-3 adorn-card mx-3 card-margin">
                <div className="icon-design">
                  <svg
                    className="mb-2"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19.63,3.65a1,1,0,0,0-.84-.2,8,8,0,0,1-6.22-1.27,1,1,0,0,0-1.14,0A8,8,0,0,1,5.21,3.45a1,1,0,0,0-.84.2A1,1,0,0,0,4,4.43v7.45a9,9,0,0,0,3.77,7.33l3.65,2.6a1,1,0,0,0,1.16,0l3.65-2.6A9,9,0,0,0,20,11.88V4.43A1,1,0,0,0,19.63,3.65ZM18,11.88a7,7,0,0,1-2.93,5.7L12,19.77,8.93,17.58A7,7,0,0,1,6,11.88V5.58a10,10,0,0,0,6-1.39,10,10,0,0,0,6,1.39ZM13.54,9.59l-2.69,2.7-.89-.9a1,1,0,0,0-1.42,1.42l1.6,1.6a1,1,0,0,0,1.42,0L15,11a1,1,0,0,0-1.42-1.42Z"
                      fill="#f28535"
                    />
                  </svg>
                </div>
                <p className="fs-5 mb-2 adorn-card-heading">Our Promise</p>
                <p className="card-description">
                  Bioversal Remedies Healthcare's concept is built on providing
                  high-quality goods to enhance people's quality of life to
                  drive us to explore, accomplish, and set new standards. We at
                  Bioversal Remedies promise to deliver substantial health care
                  goods at an accessible price to the world's suffering mankind.
                  We promise healing, deliverance and rescuing of lives keeping
                  in mind the affordability of medicines.
                </p>
              </div>
              <div className="col-sm-6 col-md-3 adorn-card mx-3 card-margin">
                <div className="icon-design">
                  <svg
                    class="feather feather-flag mb-2 mt-1"
                    fill="none"
                    height="60"
                    stroke="#f28535"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" />
                    <line x1="4" x2="4" y1="22" y2="15" />
                  </svg>
                </div>
                <p className="fs-5 mb-2 adorn-card-heading">Our Mission</p>
                <p className="card-description">
                  Our mission is to develop innovative products to fill gaps in
                  the global market and plan ahead of time. We strive to
                  introduce ingenious and effective medicines to the market and
                  provide consistent value to stakeholders. We always believe in
                  caring and healing. We believe that commitment in
                  accomplishing core goals and exploring new possibilities leads
                  to people being healed and cured.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="countup-section bg_cont__45__pcdpharma service-wraper2">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-sm-6 mb-30 counter-card-animate">
                <div className="feature-container feature-bx3">
                  <h2 className="counter text-secondary">
                    <CountUp start={300} enableScrollSpy={true} />+
                  </h2>
                  <h5 className="ttr-title">Products</h5>
                  <p>
                    Our extensive experience gives you expertise and network all
                    free.
                  </p>
                </div>
              </div>
              <div className="col-xl-3 col-sm-6 mb-30 counter-card-animate">
                <div className="feature-container feature-bx3">
                  <h2 className="counter text-secondary">
                    {" "}
                    <CountUp end={100} enableScrollSpy={true} />+
                  </h2>
                  <h5 className="ttr-title">Associates</h5>
                  <p>
                    Our awards reward you to work with a recognized pharma unit.
                  </p>
                </div>
              </div>
              <div className="col-xl-3 col-sm-6 mb-30 counter-card-animate">
                <div className="feature-container feature-bx3">
                  <h2 className="counter text-secondary">
                    {" "}
                    <CountUp end={5} enableScrollSpy={true} />+
                  </h2>
                  <h5 className="ttr-title">Special Divisions</h5>
                  <p>
                    With a wide network of doctors we offer sales and
                    profitability in advance.
                  </p>
                </div>
              </div>
              <div className="col-xl-3 col-sm-6 mb-30 counter-card-animate">
                <div className="feature-container feature-bx3">
                  <h2 className="counter text-secondary">
                    {" "}
                    <CountUp end={25} enableScrollSpy={true} />+
                  </h2>
                  <h5 className="ttr-title">States Presence</h5>
                  <p>
                    Our satisfied consumer base provides you repetitive
                    customers and revenue.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* footer */}

      <div>
        {/* Footer END ==== */}
        <button
          className="back-to-top fa fa-chevron-up"
          style={{ display: "none" }}
        />
      </div>
    </div>
  );
};

export default AboutPage;
